/**
* In this file use to contains the physician Module Parent screen UI and Logic
**/
import { Link } from 'react-router-dom';
import { goBack ,convertS3privateToPublic } from './../../../services/UtilsService';
import { useState,useEffect } from 'react';
import ApiService from './../../../services/ApiService';
import OutgoingModal from './../../../shared/modals/OutgoingModal';
import Pagination from './../../../shared/components/Pagination';
// import constantVariables from './../../../dataset/constantVariables.json';
import { useTranslation } from 'react-i18next';

function Parents() {
	
	//Intial state declaraction
	const [parentList,setParentList]=useState([]);
	const [param,setParam]=useState({page:0,limit:10});
	const [openCall,setCall]=useState({});
	const [isLoading, setIsLoading] = useState(true);
	const { t } = useTranslation();
	
	/** 
	* To handle pagination event
	* @data we pass the page number
	**/
	  const handlePaginate=(data)=>{  
		  setParam({...param,page:data});
	  };
	
	//callback function
	const handleCallClose = () => setCall({});
	
	/** 
	* handeonChange while search
	* @e we get the event details from the change action
	**/
	const handleChange =async (e) => {
		e.preventDefault();
		const {name,value}=e.target;  
		setParam({...param,[name]:value,page:0});
	};
	
	/** 
	* handeonChange while dropdown change
	* @e we get the event details from the change action
	**/
	 const handleSortChange = (e) => {
		 e.preventDefault();
		const {name,value}=e.target;  
		setParam({...param,[name]:value});
	  };
	  
	 //Component Initialize function trigger when param details change
	useEffect(()=> {
		const fetchData = async () => {
			setIsLoading(true); 
			try {
				const response = await ApiService.parentList(param);
				if (response.status === 200) {
					setParentList(response.data);
				}
			}catch (error) {
				console.error('Error fetching parent data:', error);
			} finally {
				setIsLoading(false); 
			}
		};
		fetchData();
	},[param]);
   
  return (
    <>
	<main id="main" className="main">
	
	{/*import OutgoingModal*/}
	{openCall && openCall?.isOpen && <OutgoingModal 
		show={openCall.isOpen} 
		id={openCall.id} 
		photo={openCall.photo} 
		name={openCall.name} 
		handleClose={handleCallClose}
	/>}
	
	{/*Page Title Section*/}
		<div className="pagetitle clearfix">
			<div className="float-start">
			  <h1>{t('sidebar.parents')}</h1>
				<nav>
					<ol className="breadcrumb">
					  <li className="breadcrumb-item"><Link to='/physician/dashboard'>{t('sidebar.home')}</Link></li>
					  <li className="breadcrumb-item active">{t('sidebar.parents')}</li>
					</ol>
				</nav>
			</div>
			<div className="float-end mt-2 me-1">
				<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
			</div>
		</div>
		{/*End Page Title Section*/}
		
		{/*Page Content Section*/}
		<section className="pagesection">
		<div className="row my-3">
				<div className="col-xxl-7 col-lg-7 d-flex">
					<div className="input-group input-group-sm me-2 w-50">
					  <input type="text" name="search" value={param.search?param.search:''}
						onChange={handleChange} className="form-control" placeholder={t('common.search')} />
					  <button className="btn btn-tmBlue" type="button"><i className="ri-search-line"></i></button>
					</div>
				</div>
				<div className="col-xxl-5 col-lg-5">
				
					<div className="dropdown float-end me-3">
					  <a className="btn btn-sm btn-outline-tmBlue dropdown-toggle" href="javascript;" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false"> {t('common.sort')} </a>

					  <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
					  <li>
						<button className={param.sort ==='added' ? 'dropdown-item active' : 'dropdown-item'} type="button" value="added" name="sort" onClick={handleSortChange} > {t("common.recentAdded")} </button>
					  </li>
					  <li>
						<button className={param.sort ==='updated' ? 'dropdown-item active' : 'dropdown-item'} type="button" value="updated" name="sort" onClick={handleSortChange} > {t('common.recentUpdated')} </button>
					  </li></ul>
					</div>
				</div>
			</div>
			<div className="row my-3">
				<div className="col-xxl-12">
					<div className="table-responsive">	
						<table className="table table-borderless theme-table">
							<thead>
							  <tr>
								<th scope="col">{t('table.parentName')}</th>
								<th scope="col">{t('profile.emailAddress')}</th>
								<th scope="col" className="text-center">{t('table.member')}</th>
								<th scope="col" className="text-center">{t('table.mobileNumber')}</th>
								<th scope="col" className="text-center">{t('profile.location')}</th>
							  </tr>
							</thead>
							{parentList && parentList?.details?.length ? (
							<tbody>
							{parentList && parentList.details && parentList.details.map((item,i)=>(
								<tr key={i}>
								<td >
											<div className="d-flex align-items-center ps-1">
												<div className="avtar-img">
													<span className="rounded-circle">
													{item?.photo==='default.png'?<img src="/assets/img/user-avatar.png" alt="UN" />:<img src={convertS3privateToPublic(item?.photo)} alt="UN" />}
													</span>
												</div>
												<div className="ms-2">
													<h5 className="table-title text-capitalize">{item?.first_name+' '+item?.last_name}</h5>
												</div>
											</div>		
									</td>
									<td><a href={`mailto:${item?.email}`}>{item?.email}</a></td>
									<td className="text-center"><span > {item?.members?item.members:'--'} </span></td>
									<td className="text-center"><span >{item?.mobileNumber?item?.countryCode+' '+item.mobileNumber:'--'} </span></td>
									<td className="text-center"><span >{item?.city||'--'}</span></td>
								</tr>
							))}
							</tbody>
							) : ( !isLoading && 
							<tbody>
								<tr>
									<td colSpan="11" className="text-center">{t('common.noRecord')}</td>
								</tr>
							</tbody>
							)}
						</table>
					</div>
				</div>
			</div>			
			{/*Pagination*/}
			{parentList && parentList.length !==0 && parentList?.details?.length!==0 && <div className="row my-3">
				<div className="col-xxl-12 d-flex justify-content-center">
					<Pagination page={param.page} handlePaginate={handlePaginate} total={parentList.counts}  />
				</div>
            </div>}
			{/*End Pagination*/}
		</section>
		{/*End Page Content Section*/}
	</main>
    </>
  );
}

export default Parents;
